/* Content stays visible without JavaScript. Never animate the first-screen hero. */
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const active = new Set();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (preference.matches || typeof entry.target.animate !== 'function') continue;
      const animation = entry.target.animate([
        { opacity: 0.65, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' });
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => active.delete(animation));
    }
  }, { threshold: 0.12 });
  function init(root) {
    root.querySelectorAll('[data-dc-reveal]').forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-dc-reveal]').forEach((element) => observer.unobserve(element));
    for (const animation of active) {
      if (event.target.contains(animation.effect?.target)) animation.cancel();
    }
  });
  preference.addEventListener('change', () => {
    if (preference.matches) for (const animation of active) animation.cancel();
  });
})();
